import { render, staticRenderFns } from "./RechargeOrder.vue?vue&type=template&id=0812b734&"
import script from "./RechargeOrder.vue?vue&type=script&lang=js&"
export * from "./RechargeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports